// extracted by mini-css-extract-plugin
var _1 = "xGzmV8CxlMuvQniRmdaE";
var _2 = "oaJMbT9l6goqYuiwWFW8";
var _3 = "hbylaYCwImouayAhCECk";
export { _1 as "menuItemSeparator", _2 as "menuItemSeparatorBordered", _3 as "menuItemSeparatorLine" }
export default { "menuItemSeparator": _1, "menuItemSeparatorBordered": _2, "menuItemSeparatorLine": _3 }
